import { useEffect } from "react";

export default function ApplyWeddingTheme({ theme }) {
  useEffect(() => {
    if (!theme) return;
    const r = document.documentElement.style;
    if (theme.background_color) r.setProperty("--bg", theme.background_color);
    if (theme.accent_color) r.setProperty("--accent", theme.accent_color);
    if (theme.text_color) r.setProperty("--text", theme.text_color);
    if (theme.secondary_text_color) r.setProperty("--text-secondary", theme.secondary_text_color);
    if (typeof theme.glass_opacity === "number") r.setProperty("--glass-opacity", String(theme.glass_opacity));
    if (typeof theme.glass_blur === "number") r.setProperty("--glass-blur", `${theme.glass_blur}px`);
    if (typeof theme.corner_radius === "number") r.setProperty("--radius", `${theme.corner_radius}px`);
    if (theme.heading_font) r.setProperty("--heading-font", `'${theme.heading_font}', serif`);
    if (theme.body_font) r.setProperty("--body-font", `'${theme.body_font}', sans-serif`);
    return () => {
      // Reset defaults on unmount
      r.setProperty("--bg", "#F5F6F8");
      r.setProperty("--accent", "#C7A76C");
      r.setProperty("--text", "#171717");
      r.setProperty("--text-secondary", "#737373");
      r.setProperty("--glass-opacity", "0.55");
      r.setProperty("--glass-blur", "24px");
      r.setProperty("--radius", "24px");
      r.setProperty("--heading-font", "'Cormorant Garamond', serif");
      r.setProperty("--body-font", "'DM Sans', sans-serif");
    };
  }, [theme]);
  return null;
}
